<div class="title-grid">
    <img class="title-icon" [src]="'/assets/images/reminders.svg'" />
    <h2 translate>grid.navs.reminders</h2>
</div>

<que-reminders-list></que-reminders-list>